import { gql } from '@apollo/client';
import client from 'apollo/apollo-client';
import { GET_CURRENTME } from 'apollo/account/current';

export async function notificationsConfigure(variables) {
  return await new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: CUSTOMER_NOTIFICATIONS_CONFIGURE,
        variables,
        refetchQueries: [{ query: GET_CURRENTME }],
      })
      .then(
        ({
          data: {
            CustomerNotificationsConfigure: { error, data, message },
          },
          loading,
        }) => {
          resolve({ data, loading, error, message });
        },
      )
      .catch((err) => {
        reject(new Error(err.message || '_server_error_'));
      });
  });
}

const CUSTOMER_NOTIFICATIONS_CONFIGURE = gql`
  mutation CustomerNotificationsConfigure(
    $_id: ID!
    $waGroupId: String
    $waNotifications: Boolean
    $tgGroupId: String
    $tgNotifications: Boolean
  ) {
    CustomerNotificationsConfigure(
      _id: $_id
      waGroupId: $waGroupId
      waNotifications: $waNotifications
      tgGroupId: $tgGroupId
      tgNotifications: $tgNotifications
    ) {
      error
      data {
        _id
        name
        waGroupId
        waNotifications
        tgGroupId
        tgNotifications
      }
      message
    }
  }
`;
